import { apiSlice } from "./apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Tournaments"],
});

const tournamentApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getTournament: builder.query({
      query: (id) => `/tournament/${id}`,
      providesTags: ["Tournaments"],
    }),
    getTournamentByCode: builder.query({
      query: (code) => `/tournament/by-code/${code}`,
    }),
    getMyTournaments: builder.query({
      query: ({ page = 1, per_page = 10 } = {}) =>
        `/tournament?page=${page}&per_page=${per_page}`,
      providesTags: ["Tournaments"],
    }),
    createTournament: builder.mutation({
      query: (body) => ({
        url: "/tournament",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Tournaments"],
    }),
    joinTournament: builder.mutation({
      query: (body) => ({
        url: "/tournament/join",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Tournaments"],
    }),
    inviteTournamentParticipants: builder.mutation({
      query: ({ id, schoola_ids }) => ({
        url: `/tournament/${id}/invite`,
        method: "POST",
        body: { schoola_ids },
      }),
      invalidatesTags: ["Tournaments"],
    }),
    getTournamentParticipants: builder.query({
      query: (id) => `/tournament/${id}/participants`,
      providesTags: ["Tournaments"],
    }),
    getTournamentRounds: builder.query({
      query: (id) => `/tournament/${id}/rounds`,
      providesTags: ["Tournaments"],
    }),
    startTournamentRound: builder.mutation({
      query: ({ id, subject, topics, num_questions }) => ({
        url: `/tournament/${id}/rounds/start`,
        method: "POST",
        body: { subject, topics, num_questions },
      }),
      invalidatesTags: ["Tournaments"],
    }),
    endTournamentRound: builder.mutation({
      query: ({ id, roundId }) => ({
        url: `/tournament/${id}/rounds/${roundId}/end`,
        method: "POST",
      }),
      invalidatesTags: ["Tournaments"],
    }),
    getTournamentLeaderboard: builder.query({
      query: (id) => `/tournament/${id}/leaderboard`,
      providesTags: ["Tournaments"],
    }),
    getTournamentByQuizId: builder.query({
      query: (quiz_id) => `/tournament/by-quiz/${quiz_id}`,
      providesTags: ["Tournaments"],
    }),
  }),
});

export const {
  useGetTournamentQuery,
  useGetTournamentByCodeQuery,
  useGetMyTournamentsQuery,
  useCreateTournamentMutation,
  useJoinTournamentMutation,
  useInviteTournamentParticipantsMutation,
  useGetTournamentParticipantsQuery,
  useGetTournamentRoundsQuery,
  useStartTournamentRoundMutation,
  useEndTournamentRoundMutation,
  useGetTournamentLeaderboardQuery,
  useGetTournamentByQuizIdQuery,
} = tournamentApiSlice;
